import Link from 'next/link'
import styled from 'styled-components'

import buttonStyles from '@ilg-totallymoney/ui/styles/button'

export const StyledNextLink = styled(Link)`
    ${buttonStyles};
`
